var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panels',{model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.items),function(item,i){return _c('expandable-item',{key:item.field,attrs:{"item":item,"data":_vm.data,"module-data":_vm.moduleData},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var data = ref.data;
return [_vm._t("item",null,null,{ item: item, data: data, isActive: _vm.active === i })]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }